import { FC, PropsWithChildren, useContext, useEffect, useMemo } from 'react';

import ServiceStackClientContext from '@/contexts/api/ServiceStackClientContext';
import SignalRContext from '@/contexts/api/SignalRContext';
import AuthenticatedUserContext from '@/contexts/authentication/AuthenticatedUserContext';
import { SignalRManager } from './SignalRManager';

export { SignalRManager } from './SignalRManager';

interface ISignalRProviderProps {
    baseUrl: string;
    debug?: boolean;
}

const SignalRProvider: FC<PropsWithChildren<ISignalRProviderProps>> = ({ children, baseUrl, debug }) => {
    const { data: user } = useContext(AuthenticatedUserContext);
    const client = useContext(ServiceStackClientContext);
    const manager = useMemo(() => new SignalRManager(baseUrl, debug === true, client, user), []);

    useEffect(() => {
        manager.setClient(client);
    }, [client, manager]);

    useEffect(() => {
        manager.setUser(user);
    }, [user, manager]);

    useEffect(() => () => { void manager.dispose(); }, [manager]);

    return <SignalRContext.Provider value={manager}>{children}</SignalRContext.Provider>;
};

export default SignalRProvider;
